// 不同国家对应的政府机构(部门)
export const governmentData = {
  Singapore: [
    {
      title: "Accounting & Corporate Regulatory Authority - ACRA",
      value: "ACRA",
    },
    {
      title: "Board of Architects, Singapore - BOA",
      value: "BOA",
    },
    {
      title: "Majlis Ugama Islam Singapura - MUIS",
      value: "MUIS",
    },
    {
      title: "Ministry of Culture, Community and Youth - Charities Unit",
      value: "Charities",
    },
    {
      title: "Minlaw (legal services regulatory authority) - Minlaw",
      value: "Minlaw",
    },
    {
      title: "Monetary Authority of Singapore (Banking Department) - MAS_Bank",
      value: "MAS_Bank",
    },
    {
      title: "Council for Estate Agencies - CEA",
      value: "CEA",
    },
    {
      title: "Enterprise Singapore - CTA",
      value: "CTA",
    },
    {
      title: "Minsitry of Defence - Diso - Mindef",
      value: "Mindef",
    },
    {
      title: "Minsitry of education - private schools section - MOE",
      value: "MOE",
    },
    {
      title: "Professional Engineers Board - Professional Engineers Board",
      value: "Professional",
    },
    {
      title: "Singapore Tourism Board - STB",
      value: "STB",
    },
    {
      title: "Enterprise Singapore - RCA",
      value: "RCA",
    },
    {
      title: "Ministry of foreign affairs - MF",
      value: "MFA",
    },
  ],
  Malaysia: [
    {
      value: "SSM",
      title: "Companies Commission of Malaysia - SSM",
    },
    {
      value: "BNM",
      title: "Central Bank of Malaysia - BNM",
    },
    {
      value: "LHDN",
      title: "Inland Revenue Board of Malaysia - LHDN",
    },
    {
      value: "MIDA",
      title: "Malaysian Investment Development Authority - MIDA",
    },
    {
      value: "SC",
      title: "Securities Commission Malaysia - SC",
    },
    {
      value: "MITI",
      title: "Ministry of Investment, Trade and Industry - MITI",
    },
    {
      value: "MOF",
      title: "Ministry of Finance - MOF",
    },
    {
      value: "MCMC",
      title: "Malaysian Communications and Multimedia Commission - MCMC",
    },
    {
      value: "MOH",
      title: "Ministry of Health - MOH",
    },
    {
      value: "MOE",
      title: "Ministry of Education - MOE",
    },
    {
      value: "MHE",
      title: "Ministry of Higher Education - MHE",
    },
    {
      value: "MOT",
      title: "Ministry of Transport - MOT",
    },
    {
      value: "MFA",
      title: "Ministry of Foreign Affairs - MFA",
    },
    {
      value: "MINDEF",
      title: "Ministry of Defence - MINDEF",
    },
    {
      value: "MOHR",
      title: "Ministry of Human Resources - MOHR",
    },
    {
      value: "JAKIM",
      title: "Department of Islamic Development Malaysia - JAKIM",
    },
    {
      value: "BEM",
      title: "Board of Engineers Malaysia - BEM",
    },
    {
      value: "LAM",
      title: "Board of Architects Malaysia - LAM",
    },
    {
      value: "BOVAEP",
      title: "Board of Valuers, Appraisers, Estate Agents and Property Managers - BOVAEP",
    },
    {
      value: "Tourism Malaysia",
      title: "Malaysia Tourism Promotion Board - Tourism Malaysia",
    },
  ],
};
